import {parseISO} from 'date-fns'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import commonStyles from '../styles.module.scss'
import {Text, Button, Modal} from 'common/components'
import {useGetForecast} from 'common/api'
import {useOpen} from 'common/hooks'
import {RequestDecline, RequestOpenForm, CheckActionsProps} from '..'

export default function RequestOpenActions({
  // role,
  request,
  isRequestLoading,
}: CheckActionsProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const {data: forecast, isRefetching: isForecastRefetching} = useGetForecast(
    request?.project?.uuid, !!request?.project?.uuid
  )
  const [isOpen, handleOpen, handleClose] = useOpen()

  const currentForecast = forecast?.map((item) => ({
    uuid: item.uuid,
    type: item.type,
    date: parseISO(item.value.date),
    amount: item.value.amount,
  }))

  const isNotAllowed = !permissions?.includes('edit loan request (ready to open)')
  
  return (
    <>
      <div className={commonStyles.checkActions}>
        <Text size="xs">
          <Text as="span" weight="demiBold">
            Lending Manager
          </Text>{' '}
          need to confirm the fees and enter the Initial drawdown amount
        </Text>
        { !isNotAllowed && (
          <>
            <div>
              <Button
                disabled={isRequestLoading || isForecastRefetching}
                onClick={handleOpen}
              >
                Confirm fees & open project
              </Button>
              <RequestDecline
                requestUuid={request.uuid}
                requestStatus={request.status}
                disabled={isRequestLoading}
              />
            </div>
            <Modal
              width={600}
              title="Confirmation of loan opening"
              open={isOpen}
              onCancel={handleClose}
            >
              <RequestOpenForm forecast={currentForecast} request={request} />
            </Modal>
          </>
        )}
      </div>
    </>
  )
}
